import { create } from 'zustand'

import { type ForbiddenErrorStateInfo } from './forbidden-error-states'

interface ChildResourceForbiddenState {
  activeError: ForbiddenErrorStateInfo | null
  trigger: (error: ForbiddenErrorStateInfo) => void
  reset: () => void
}

export const childResourceForbiddenStore = create<ChildResourceForbiddenState>(set => ({
  activeError: null,
  trigger: error => set({ activeError: error }),
  reset: () => set({ activeError: null })
}))
